<template>
  <v-card align="center" justify="center" min-width="21vw" outlined>
    <v-card-title>
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title_ChannelOptions', { name: capitalize(channel.name) }) }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-7">
      <v-row justify="center" v-if="!confirmDeleteView">
        <v-col>
          <p>{{ $t('description_ChannelOptions') }}</p>
          <div>
            <v-btn style="width: 100%;" class="mt-2" @click="changeVisibility">{{ $t('btnMake') }} {{ getOtherVisibility() }}</v-btn>
            <v-btn style="width: 100%;" class="mt-2 remove-button" @click="confirmDeleteView = true">{{ $t('btnRemove_ChannelOptions') }}</v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" v-else>
        <v-col>
          <p class="mt-n2" v-html="$t('removing.message', {name: capitalize(channel.name) })"/>
          <v-text-field v-model="confirmingDeleteName" :placeholder="channel.name.toUpperCase()" outlined/>
          <div class="d-flex justify-center">
            <v-btn @click="confirmDeleteView = false">« {{ $t('btnCancel_ChannelOptions') }}</v-btn>
            <v-btn class="ml-2 remove-button" style="width: 50%;" :disabled="confirmingDeleteName !== channel.name" @click="removeChannel">
              {{ $t('removing.btnConfirmRemove') }}</v-btn>
          </div>
          <v-divider class="my-7"/>
          <p class="mt-2 mb-n3"><v-icon class="mr-2 mt-n1" small>fa-exclamation-circle</v-icon>{{ $t('removing.alert') }}</p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';
export default {
  name: "ChannelOptions",
  props: {
    channel: Object,
  },
  data() {
    return {
      confirmingDeleteName: '',
      confirmDeleteView: false,
    };
  },
  watch: {
    confirmingDeleteName() {
      this.confirmingDeleteName = this.confirmingDeleteName.replace(' ', '_').toUpperCase();
    },
  },
  methods: {
    getOtherVisibility() {
      return this.channel.visibility !== 'PUBLIC'? this.$t('visibility.public') : this.$t('visibility.private');
    },
    ...mapMutations(['setClubChannels', 'setClubPublicChannels']),
    changeVisibility() {
      this.channel.visibility = (this.channel.visibility === 'PUBLIC')? 'PRIVATE' : 'PUBLIC';
      Repository.modifyClubChannel(this.channel).then((response) => {
        if(response.status < 400) {
          alert(this.$t('confirm.visibility', { name: this.capitalize(this.channel.name) }));

          // Refresh Public Channels
          Repository.getAllPublicClubChannels(this.$store.state.clubMember.club.id).then((secondResponse) => {
            if(secondResponse.status < 400) {
              this.setClubPublicChannels(secondResponse.data);
            }
          });

          // Refresh All Channels
          Repository.getAllClubChannels(this.$store.state.clubMember.club.id).then((secondResponse) => {
            if(secondResponse.status < 400)
              this.setClubChannels(secondResponse.data);
          });
        }
      });
    },
    ...mapMutations(['setClubChannels', 'resetCurrentClubChannel', 'setClubPublicChannels', 'setClubChannelsContributedByMe']),
    removeChannel() {
      if(this.$store.state.currentClubChannel.id === this.channel.id)
        this.resetCurrentClubChannel();

      Repository.deleteClubChannel(this.channel.id).then((response) => {
        if(response.status < 400) {
          alert(this.$t('confirm.remove', { name: this.capitalize(this.channel.name) }));

          // Refresh My Contributions
          if(this.validateNotExistingContribution())
            Repository.getAllClubChannelsByContributor(this.$store.state.clubMember.id).then((secondResponse) => {
              if(secondResponse.status < 400)
                this.setClubChannelsContributedByMe(secondResponse.data);
            });

          // Refresh Public Channels
          if(this.channel.visibility === 'PUBLIC')
            Repository.getAllPublicClubChannels(this.$store.state.clubMember.club.id).then((secondResponse) => {
              if(secondResponse.status < 400) {
                this.setClubPublicChannels(secondResponse.data);
              }
            });

          // Refresh All Channels
          Repository.getAllClubChannels(this.$store.state.clubMember.club.id).then((secondResponse) => {
            if(secondResponse.status < 400)
              this.setClubChannels(secondResponse.data);
          });

          this.close();
        }
        else
          alert('An error occurred');
      });
    },
    validateNotExistingContribution() {
      return this.$store.state.clubChannelsContributedByMe.find((contribution) => contribution.clubChannel.id === this.channel.id) !== undefined;
    },
    capitalize(string){
      return string[0] + string.slice(1).toLowerCase();
    },
    close() {
      this.$emit('closeWindow');
    },
  },
}
</script>



<style scoped>
  .remove-button {
    background-color: #FF4747 !important;
    color: #FFFFFF !important;
    border: #FF4747 solid 2px !important;
  }

  .remove-button:hover {
    background-color: #FF4747 !important;
    color: #FFFFFF !important;
    border: #FF4747 solid 2px !important;
  }
</style>
